import { Pipe, PipeTransform, inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { displayName } from './display-name';

/** The stand-ins the backend writes where no person acted, and what each is called on screen. */
const ACTOR_LABEL_KEY: Record<string, string> = {
  member: 'guaranteeV2.label.actorMember',
  system: 'guaranteeV2.label.actorSystem',
};

/**
 * Who acted, as a `*ByName` field reads it: a health manager by name, the member or the system by
 * what they are called here, and an unresolved id as nothing at all.
 */
@Pipe({
  name: 'guaranteesActorName',
  standalone: true,
})
export class ActorNamePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(name: string | undefined): string | undefined {
    const shown = displayName(name);
    if (!shown) {
      return undefined;
    }

    const key = ACTOR_LABEL_KEY[shown.toLowerCase()];

    return key ? this.translate.instant(key) : shown;
  }
}
